import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46fa5d7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex gap-5" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "step-title" }
const _hoisted_5 = { class: "step-text" }

import { computed } from 'vue';

// import { getActiveClassName } from '@/components/utils';
import { StepState } from '@/types';

type Props = {
  title: string;
  steps: Step[];
};

type Step = {
  tooltip: string;
  state: StepState;
  label?: number;
  isVisible?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    steps: null
  },
  emits: ['navigate'],
  setup(__props: any, { emit }) {

const props = __props as {
  title: string;
  steps: Step[];
}




/**
 * COMPUTED
 */
const visibleSteps = computed(() => {
  return props.steps.filter(
    step => step.isVisible === undefined || step.isVisible
  );
});

// const stepTextClasses = computed(() => {
//   return visibleSteps.value.map(step => {
//     return getActiveClassName(step.state, [
//       [
//         StepState.Active,
//         'text-blue-600 dark:text-blue-400 font-semibold hover:text-blue-800',
//       ],
//       [StepState.Todo, 'text-gray-400 font-normal'],
//       [StepState.Success, 'text-green-500 font-semibold'],
//       [StepState.Warning, 'text-red-500 font-semibold'],
//       [StepState.Completed, 'text-gray-700 font-medium'],
//     ]);
//   });
// });

// const stepCircleClasses = computed(() => {
//   return visibleSteps.value.map(step => {
//     return getActiveClassName(step.state, [
//       [
//         StepState.Active,
//         'border-2 border-none bg-gradient-from-l bg-gradient-to-r from-blue-600 to-blue-400 text-white active',
//       ],
//       [
//         StepState.Todo,
//         'border-2 border-gray-300 dark:border-gray-600 text-secondary',
//       ],
//       [
//         StepState.Success,
//         'border-2 border-none bg-gradient-to-tr from-green-500 to-green-200 text-white',
//       ],
//       [StepState.Warning, 'border-2 border-none bg-red-500 text-white active'],
//       [StepState.Completed, 'border-2 border-gray-600 font-medium'],
//     ]);
//   });
// });

/**
 * FUNCTIONS
 */
function handleNavigate(state: StepState, stepIndex: number) {
  if (state === StepState.Todo) return;
  emit('navigate', stepIndex);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleSteps), (step, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `vertical-step-${step.tooltip}`,
          class: _normalizeClass([
          'step-item',
          { 'step-item-active': step.state === _unref(StepState).Active },
        ])
        }, [
          _createElementVNode("button", {
            class: _normalizeClass({ 'cursor-default': step.state === _unref(StepState).Todo }),
            onClick: ($event: any) => (handleNavigate(step.state, i))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, "Step " + _toDisplayString(i + 1), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(step.tooltip), 1)
            ])
          ], 10, _hoisted_2)
        ], 2))
      }), 128))
    ])
  ]))
}
}

})